import React from 'react';
import { styled } from '@mui/material';

type SpaceProps = {
    gap?: number;
    horizontal?: boolean;
};

const SpaceDiv = styled('div', {
    shouldForwardProp: (prop) => prop !== 'gap' && prop !== 'horizontal',
})<SpaceProps>(({ theme, gap = 4, horizontal }) => ({
    ...(horizontal
        ? {
              display: 'inline-block',
              height: '100%',
              width: theme.spacing(gap),
          }
        : {
              width: '100%',
              height: theme.spacing(gap),
          }),
}));

const Space: React.FCC<SpaceProps> = (props) => {
    return <SpaceDiv {...props} />;
};

export default React.memo(Space);
